import { styled } from 'styled-components';
import scheduleImg from '../assets/optimized/schedule-scaley.svg';

export const ScheduleImgSrc = scheduleImg;

export default function Schedule() {
    return (
        <Container>
            <Image src={scheduleImg} alt="Wedding Schedule" />
        </Container>
    );
}

const Container = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`;

const Image = styled.img`
    position: relative;
    width: 100%;
    height: auto;
    display: block;
`;